/**
 * Static company/contact info -- the single source of truth for the Contact
 * page AND the site Footer (per explicit product decision: both must show
 * the same info, so it lives once at app level in `src/content/`, not inside
 * the `contact` feature, to avoid a layout importing from a feature's
 * internals). Real data provided directly by the client (Daruosh) on
 * 2026-08-10.
 *
 * Fields intentionally left as explicit placeholders (per client instruction:
 * "هیچ اطلاعاتی را حدس نزن") rather than real values:
 *  - `instagram.href` is null -- no username/URL was given yet. The UI must
 *    render the Instagram entry without a link until this is filled in.
 *  - No second office (e.g. Tabriz) is listed -- only the Tehran head office
 *    was confirmed.
 */
export interface SocialLink {
  platform: 'instagram' | 'whatsapp';
  label: string;
  /** null = not yet available; the UI shows the label without a link. */
  href: string | null;
}

export interface ContactInfoContent {
  companyName: string;
  foundedYear: string;
  registeredCapital: string;
  officeLabel: string;
  address: string;
  phone: string;
  whatsappHref: string;
  email: string;
  workingHours: string;
  socialLinks: SocialLink[];
}

export const contactInfoContent: ContactInfoContent = {
  companyName: 'داریوش معدن آذر',
  foundedYear: '۱۴۰۰',
  registeredCapital: '۲۲ میلیارد ریال',
  officeLabel: 'دفتر مرکزی — تهران',
  address: 'تهران، پونک شمالی، بلوار المهدی، نبش یکم شرقی، پلاک ۹، طبقه اول، واحد ۶',
  phone: '09197045499',
  whatsappHref: 'https://wa.me/989197045499',
  email: 'info@dariushmadan.com',
  workingHours: 'شنبه تا پنجشنبه: ۷:۳۰ الی ۱۶:۰۰',
  socialLinks: [
    { platform: 'whatsapp', label: 'واتساپ', href: 'https://wa.me/989197045499' },
    { platform: 'instagram', label: 'اینستاگرام', href: null }
  ]
};
